/**
 * The page's schedule of its own chain's later strips (ADR-073's amendment "the Strike combo and the Heavy Strike
 * chain", item 8): after the first strip starts on intent, each later blow's strip starts at its time from the press,
 * until a refusal, a stun or a death clears what has not started. One chain at most; the slots are preallocated, so
 * reading it each frame allocates nothing.
 */

/**
 * The most later strips a chain schedules: the rules' 8 blows less the first.
 */
const MAX_LATER = 7;

/**
 * The strips due and when.
 */
export class ChainSchedule {
  private readonly strips: string[] = new Array<string>(MAX_LATER).fill("");
  private readonly at = new Float64Array(MAX_LATER);
  private count = 0;
  private next = 0;

  /**
   * Schedules a chain's later strips from a press, replacing any schedule held.
   *
   * @param strips The later blows' strips, in order, at most 7.
   * @param offsetsMs Each one's time after the press, in ms.
   * @param nowMs The press's scene time in ms.
   */
  public start(strips: readonly string[], offsetsMs: readonly number[], nowMs: number): void {
    this.count = Math.min(strips.length, MAX_LATER);
    this.next = 0;
    for (let index = 0; index < this.count; index += 1) {
      this.strips[index] = strips[index] as string;
      this.at[index] = nowMs + (offsetsMs[index] as number);
    }
  }

  /**
   * Drops every strip not yet started.
   */
  public clear(): void {
    this.count = 0;
    this.next = 0;
  }

  /**
   * Whether strips are still to start.
   *
   * @returns True while one waits.
   */
  public get pending(): boolean {
    return this.next < this.count;
  }

  /**
   * The strip whose time has come, taken from the schedule: at most one a call, the earliest first.
   *
   * @param nowMs Scene time in ms.
   * @returns The strip, or null when none is due.
   */
  public due(nowMs: number): string | null {
    if (this.next >= this.count || (this.at[this.next] as number) > nowMs) {
      return null;
    }
    const strip = this.strips[this.next] as string;
    this.next += 1;
    return strip;
  }
}
